import { useEffect, useRef, useState } from 'react';
export function useUpdateTimer(coolDown, generateText) {
    if (generateText === void 0) { generateText = function (timer) {
        return timer > 0 ? "Get a new code in ".concat(timer) : 'Get a new code';
    }; }
    var interval = useRef(null);
    var _a = useState(coolDown), timer = _a[0], setTimer = _a[1];
    useEffect(function () {
        if (interval.current === null && timer > 0) {
            interval.current = setInterval(function () {
                setTimer(function (prev) { return prev - 1; });
            }, 1000);
        }
        if (interval.current && timer <= 0) {
            clearInterval(interval.current);
            interval.current = null;
        }
    }, [timer]);
    return {
        setTimer: setTimer,
        text: generateText(timer),
        process: timer > 0,
    };
}
